module.exports = __webpack_public_path__ + "img/1578209992.173be4c2.jpg";